/* eslint-disable no-unused-expressions */

import DeleteFile from '../components/DeleteFile';

const DeleteFileContainer = ({
    visible, setVisible, fileExplorerDataSource, selectedFiles, parentDir, onConfirmDelete,
}) => {
    const filesToDelete = [];

    selectedFiles && selectedFiles.forEach(file => {
        const result = fileExplorerDataSource && fileExplorerDataSource.find(element => element.id === file);
        if (result) {
            filesToDelete.push(result);
        }
    });

    const fileOrFolderInput = filesToDelete && filesToDelete.map(item => ({ id: item.originalId, type: item.type }));

    const inputTypes = filesToDelete && filesToDelete.map(item => (item.type));

    const onSave = async () => {
        onConfirmDelete({
            dirId: parentDir,
            deleteList: fileOrFolderInput,
        });
    };

    return (
        <DeleteFile
            visible={visible}
            setVisible={setVisible}
            onSave={onSave}
            inputTypes={inputTypes}
        />
    );
};

export default DeleteFileContainer;
